module.exports = {"voucher_title":"Costco Members receive an additional {{value}} toward their finance or lease"}